import React, { useRef } from 'react';
import { useClickOutside } from '@carnica/utils/hooks';
import { compose } from '@beef/utils';
import { useEventListener, withMountListener } from '@beef/react';
import { createPortal } from 'react-dom';
import { cnComponentsTheme } from '@carnica/ui-kit/styles';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { sideMenuStore } from "../../../../../../../../store";
import { ConnectionBlockActionCreator } from "../../../../../store/actions";
import { selectBalancesForRendering, selectBalancesLoading, selectWasBonusModalOpened } from "../../../../../../../../store/selectors";
import { useCalculateStyles } from "./hooks/useCalucateStyles";
import { BalanceItem } from "../BalanceItem";
import styles from "../styles.pcss";
var theme = cnComponentsTheme('dark');
var cn = classNames.bind(styles);
export var _Balances = function _Balances(_ref) {
  var _parentRef$current;
  var parentRef = _ref.parentRef,
    balances = _ref.balances,
    isLoading = _ref.isLoading,
    isMobile = _ref.isMobile,
    onClickOutside = _ref.onClickOutside,
    siblingRef = _ref.siblingRef;
  var balancesWrapperRef = useRef(null);
  var parentRect = (_parentRef$current = parentRef.current) === null || _parentRef$current === void 0 ? void 0 : _parentRef$current.getBoundingClientRect();
  useClickOutside({
    ignoreClicksInsideRefs: [balancesWrapperRef, siblingRef],
    isActive: true,
    onClick: onClickOutside
  });
  var _useCalculateStyles = useCalculateStyles({
      isMobile: isMobile,
      parentRect: parentRect
    }),
    style = _useCalculateStyles.style,
    setBalancesWrapper = _useCalculateStyles.setBalancesWrapper;
  var balancesWrapperCallbackRef = function balancesWrapperCallbackRef(el) {
    if (el && balancesWrapperRef.current !== el) {
      balancesWrapperRef.current = el;
      setBalancesWrapper(el);
    }
  };
  useEventListener('scroll', onClickOutside, globalThis, {
    mode: {
      capture: true,
      passive: true
    }
  });
  useEventListener('resize', onClickOutside, globalThis);
  return /*#__PURE__*/createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn('overlay'),
    "data-t-id": "BalancesSelect-Balances"
  }), /*#__PURE__*/React.createElement("div", {
    className: cn(theme, 'balancesWrapper', isLoading && 'loading'),
    ref: balancesWrapperCallbackRef,
    style: style
  }, balances === null || balances === void 0 ? void 0 : balances.map(function (balance) {
    return /*#__PURE__*/React.createElement(BalanceItem, balance);
  }))), document.body);
};
/* eslint @typescript-eslint/no-floating-promises: 0 */
var mapStateToProps = function mapStateToProps(state) {
  return {
    balances: selectBalancesForRendering(state),
    isLoading: selectBalancesLoading(state)
  };
};
var mapDispatchToProps = {
  onMount: function onMount() {
    return function (dispatch) {
      if (!selectWasBonusModalOpened(sideMenuStore.getState())) {
        dispatch(ConnectionBlockActionCreator.fetchBalances());
      }
    };
  }
};
export var Balances = compose(connect(mapStateToProps, mapDispatchToProps), withMountListener)(_Balances);